import React, { useState, useEffect, useContext } from 'react';
import { Stack } from '@fluentui/react';
import TextGridHeader from '../TextGridHeader/TextGridHeader';
import FieldComboGrid from '../FieldComboGrid/FieldComboGrid';
import { API } from '../../API/API';
import { ReactComponent as DeleteIcon } from '../../svg/deleteIcon.svg';
import { showLoadScreen, hideLoadScreen } from '../LoadScreen/LoadScreen';
import { Color, constData } from '../../const/Const';
import FieldTextGrid from '../FieldTextGrid/FieldTextGrid';
import FieldItemListGrid from '../FieldItemListGrid/FieldItemListGrid';
import { MessageConst } from '../../const/MessageConst';

const GridBasis = (props) => {

    const [initData, setInitData] = useState(
        {
            basisid: null,
            basisname: null,
            name: null,
            note: null,
            rowstate: 0
        }
    );

    const [data, setData] = useState([{ ...initData }]);

    const getExistData = () => {
        let tData = [{ ...initData }];
        if (props?.defaultValue?.length > 0) {
            if (props.defaultValue.map(r => r.rowstate).indexOf(0) < 0) {
                tData = props.defaultValue.concat([{ ...initData }]);
            } else {
                tData = props.defaultValue;
            }

        }
        tData?.map(r => {
            if (r.name) {
                r.basisname = r.name
            }
        });
        setData(tData);
    }

    useEffect(() => {
        getExistData();
    }, [props.defaultValue])

    const onEdit = (p_index, p_field, p_value, p_fieldname, p_valuename, p_full) => {

        let tData = [...data];
        tData[p_index][p_field] = p_value;
        tData[p_index][p_fieldname] = p_valuename;
        if (p_value) {
            tData[p_index].rowstate = 1;
        } else {
            tData[p_index].rowstate = 0;
        }

        if (p_field == "basisid") {
            if (p_full?.note) {
                tData[p_index]["note"] = p_full.note;
            } else {
                tData[p_index]["note"] = null;
            }
        }

        setData(tData);
        if (props.onChanged) {
            props.onChanged(tData, '', props.keyfield);
        }
    }

    const onDelete = (p_index) => {
        let tData = [...data];

        tData.splice(p_index, 1);

        setData(tData);
        if (props.onChanged) {
            props.onChanged(tData, '', props.keyfield);
        }
    }

    return (
        <div>
            <div style={{ fontSize: 18 }}>
                {props.title ? props.title : "Үндэслэл"}
            </div>
            <div style={{ marginTop: 16 }}>
                <Stack horizontal>
                    <Stack.Item grow>
                        <div style={{ borderBottom: '1px solid #EDEBE9', paddingBottom: 11, display: 'flex' }}>
                            <TextGridHeader value="Хуулийн заалт" />
                            {props.required && (<div style={{ color: Color.red }}>*</div>)}
                        </div>
                        {data?.map((r, index) => {
                            let vBorder = {
                                borderBottom: '1px solid #EDEBE9'
                            };
                            if (r.rowstate == 0) {
                                vBorder = {};
                            }
                            return (
                                <div key={index} style={{ display: 'flex', alignItems: 'center', paddingTop: 8, paddingBottom: 8, ...vBorder }}>
                                    {r.rowstate != 0 ? (
                                        <div onClick={() => onDelete(index)} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}><DeleteIcon /></div>
                                    ) : (
                                        <div style={{ width: 20, height: 20 }}></div>
                                    )}
                                    <div style={{ marginLeft: 8, width: '100%' }}>
                                        <FieldItemListGrid onChanged={onEdit} keyfield='basisid' keyfieldname='basisname' index={index} defaultValue={[{ key: r.basisid, name: r.basisname }]} dataurl={props.dataurl ?? "/api/humanresource/employment/get_basis_dropdown"} body={props.data} />
                                    </div>
                                </div>
                            );
                        })}

                    </Stack.Item>
                    <Stack.Item grow>
                        <div style={{ borderBottom: '1px solid #EDEBE9', paddingBottom: 11, paddingLeft: 16 }}>
                            <TextGridHeader value="Хуулийн заалтын өгүүлбэр" />
                        </div>
                        {data?.map((r, index) => {
                            let vBorder = {
                                borderBottom: '1px solid #EDEBE9'
                            };
                            if (r.rowstate == 0) {
                                vBorder = {};
                            }
                            return (
                                <div key={index} style={{ paddingTop: 8, paddingBottom: 8, ...vBorder }}>
                                    <FieldTextGrid disable={true} keyfield='note' index={index} onChanged={onEdit} name='Хуулийн заалтын өгүүлбэр' value={r.note} />
                                </div>
                            );
                        })}
                    </Stack.Item>
                </Stack>
                {(props.required && data?.filter(r => r.rowstate != 0).length == 0 && props.checkreq) ? (
                    <div style={{ color: 'rgb(164, 38, 44)', fontSize: 12, fontWeight: 400, paddingTop: 5, paddingBottom: 16 }}>
                        {"Хуулийн заалт" + MessageConst.fieldRequired}
                    </div>
                ) : null}
            </div>
        </div>
    );
}

export default GridBasis;